import {
  computeUrlWithQueryParameters,
  ENDPOINTS,
  INCLUDES,
} from 'src/shared/utils/endpoints'

export function buildPersonUrl(id: string, includes: string[] = []) {
  return computeUrlWithQueryParameters(ENDPOINTS.person(id), [
    INCLUDES.person(includes),
  ])
}

export function buildPersonRelationsMapUrl(personId: string) {
  return computeUrlWithQueryParameters(ENDPOINTS.personRelationsMap(personId))
}

export function buildPersonCareerUrl(personId: string) {
  return computeUrlWithQueryParameters(ENDPOINTS.personCareer(personId))
}

export function buildPersonRetirementFundsUrl(
  personId: string,
  queryParameters: string[] = [],
) {
  return computeUrlWithQueryParameters(
    ENDPOINTS.personRetirementFunds(personId),
    queryParameters,
  )
}

export function buildPersonRetirementTrimestersBuybackUrl(
  personId: string,
  queryParameters: string[] = [],
) {
  return computeUrlWithQueryParameters(
    ENDPOINTS.personRetirementTrimestersBuyback(personId),
    queryParameters,
  )
}

export function buildPersonCircuitsUrl(
  personId: string,
  queryParameters: string[] = [],
) {
  return computeUrlWithQueryParameters(
    ENDPOINTS.circuits(personId),
    queryParameters,
  )
}

export function buildLinxoAddGlobalConsentUrl(userId: string) {
  return computeUrlWithQueryParameters(ENDPOINTS.linxoAddGlobalConsent(userId))
}

export function buildLinxoSynchronizeUrl(userId: string) {
  return computeUrlWithQueryParameters(ENDPOINTS.linxoSynchronize(userId))
}

export function buildLinxoAggregateUrl(userId: string) {
  return computeUrlWithQueryParameters(ENDPOINTS.linxoAggregate(userId))
}

export function buildLinxoAccountsUrl(userId: string, accountId?: string) {
  return computeUrlWithQueryParameters(
    ENDPOINTS.linxoAccounts(userId, accountId),
  )
}

export function buildLinxoAccountsAllListStatusUrl(userId: string) {
  return computeUrlWithQueryParameters(
    ENDPOINTS.linxoAccountsAllListStatus(userId),
  )
}

export function buildLinxoEditCredentialsUrl(
  userId: string,
  accountId: string,
) {
  return computeUrlWithQueryParameters(
    ENDPOINTS.linxoEditCredentials(userId, accountId),
  )
}

export function buildLinxoManageAccountsUrl(userId: string, accountId: string) {
  return computeUrlWithQueryParameters(
    ENDPOINTS.linxoManageAccounts(userId, accountId),
  )
}

export function buildStudiesUrl(
  userId: string,
  queryParameters: string[] = [],
) {
  return computeUrlWithQueryParameters(
    ENDPOINTS.studies(userId),
    queryParameters,
  )
}

export function buildPatrimonialIndicatorsUrl(
  userId: string,
  queryParameters: string[] = [],
) {
  return computeUrlWithQueryParameters(
    ENDPOINTS.patrimonialIndicators(userId),
    queryParameters,
  )
}

export function buildPersonCallToActionUrl(queryParameters: string[] = []) {
  return computeUrlWithQueryParameters(
    ENDPOINTS.personCallToAction(),
    queryParameters,
  )
}

export function buildStudiesIndicatorUrl(
  userId: string,
  queryParameters: string[] = [],
  includes: string[] = [],
) {
  return computeUrlWithQueryParameters(ENDPOINTS.studiesIndicator(userId), [
    ...queryParameters,
    INCLUDES.studiesIndicator(includes),
  ])
}
